const BATCH_INDEX_DESCRIPTION_SEARCH = ' index [0-9]+ ';
let errorsTranslations: Record<string, string> | undefined = undefined;

export const setErrorsTranslations = (translations?: Record<string, string>) => {
	errorsTranslations = translations;
};

export default function getTextAndTranslateFromError(err: any) {
	let errorCode: string = err?.connectorError?.request?.status
		? ` (code erreur ${err?.connectorError?.request?.status})`
		: '';
	let index: number | undefined;

	let textError = (
		err?.connectorError?.response?.data?.description
		|| err?.connectorError?.response?.data?.['hydra:description']
		|| err?.connectorError?.response?.data?.message
		|| err?.connectorError?.response?.data?.header?.message
		|| err?.connectorError?.message
		|| err?.response?.data?.header?.message
		|| err?.response?.data?.['hydra:description']
		|| err?.response?.data?.description
		|| err.message
	);

	if (typeof textError === 'string' && textError === err?.response?.data?.description) {
		const batchIndexSubstring = textError.match(BATCH_INDEX_DESCRIPTION_SEARCH)?.at(0);
		index = batchIndexSubstring ? parseInt(batchIndexSubstring.replace(/[^0-9]/g, "")) : undefined;
		try {
			const detail = typeof err.response?.data?.detail === 'string'
				? JSON.parse(err.response?.data?.detail) as { description?: string; status?: number }
				: undefined;
	
			if (detail && index !== undefined) {
				textError = detail.description || 'Erreur';
				errorCode = detail.status ? ` (code erreur ${detail.status.toString()})` : errorCode;
			}
		} catch { /* empty */ }
	}
	const textErrorTranslated = errorsTranslations ? (errorsTranslations[textError] || textError) : textError;

	let description: string | undefined = textErrorTranslated + errorCode;

	if (description === 'undefined') {
		description = undefined;
	}

	if (index !== undefined) {
		return `Élément n°${index + 1}: ${description}`;
	}
	return description;
}
